module.exports = __webpack_public_path__ + "img/38.3f2dc1cb.svg";